<div class="background">
  <div class="main-block">
    <div class="header">
      <div class="back-button" (click)="returnToLogin()"></div>
      <div class="header-text">К сожалению, не нашли ваш аккаунт в системе DexBee</div>
    </div>
    <div class="info-text">
      Возможно, при регистрации вы указали другой способ входа или другую почту. Или вы еще не зарегистрировались в
      системе.
    </div>
    <div class="qr-block">
      <div class="qr"></div>
      <div class="register-text">Для регистрации установите мобильное приложение DexBee на свой телефон по QR-коду</div>
    </div>
  </div>
</div>
